import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const navigate = useNavigate();

  const scrollToContact = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  return (
    <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-blue-50 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Scale your business{' '}
              <span className="text-blue-600">without pain.</span>
              <br />
              Spend on marketing that{' '}
              <span className="text-blue-600">converts.</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
              Upscale helps startups gain early adopter traction and sustained user growth at a fraction of the cost through lean growth strategy.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6 group shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Book a Free Session
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/dddtwxqf_ChatGPT%20Image%20Jun%201%2C%202026%2C%2008_12_56%20AM.png"
                alt="Data-driven funnels and measurable growth — Upscale's marketing performance system"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
            <div className="absolute -bottom-8 -left-4 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;